export default {
  title: 'Coș',
  buttons: {
    login_to_checkout: 'Conectează-te pentru a finaliza comanda',
    checkout: 'Finalizează comanda',
  },
  go_to_menu: 'Mergi la meniu',
  toasts: {
    cashback_points_removed: 'Soldul tău de puncte s-a schimbat, așa că am eliminat punctele din această comandă.',
  },
};
